import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      const val = params[key];
      if (val !== undefined && val !== null && val !== "") {
        queryParams.append(key, val.toString());
      }
    });
  }
  const query = queryParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}

function getRequests(params: {
  limit: number;
  skip: number;
  keyword?: string;
  owner?: string;
  country?: string;
  status?: string;
  sourcingStatus?: string;
  startDate?: string;
  endDate?: string;
}) {
  const baseUrl = "requests";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching requests:", error);
  }
}

function createRequestApi(params: {
  country: string;
  comment: string;
  description: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
}) {
  const baseUrl = "requests";
  const url = buildUrl(baseUrl);

  try {
    return getApiInstance().post(url, params);
  } catch (error) {
    console.error("Error creating request:", error);
  }
}

function deleteRequestApi(params: { ids: string[] }) {
  const baseUrl = "requests";
  const url = `${baseUrl}/delete`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error Deletting request:", error);
  }
}

function updateRequestApi(params: {
  id: string;
  comment: string;
  description: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
}) {
  const baseUrl = "requests";
  const url = `${baseUrl}/${params.id}`;
  try {
    return API.put(url, params);
  } catch (error) {
    console.error("Error updating request:", error);
  }
}

function updateStatusRequestApi(params: { id: string }) {
  const baseUrl = "requests";
  const url = `${baseUrl}/status/${params.id}`;
  try {
    return API.put(url, params);
  } catch (error) {
    console.error("Error updating request:", error);
  }
}

function getRequest(params: { id: string }) {
  const baseUrl = "requests";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching request:", error);
  }
}

function assignAgentsApi(params: { id: string; agentIds: string[] }) {
  const url = `requests/${params.id}/assign-agents`;
  try {
    return getApiInstance().put(url, { agentIds: params.agentIds });
  } catch (error) {
    console.error("Error assigning agents:", error);
  }
}

function submitQuoteApi(params: {
  id: string;
  quotedPricePerUnit: number;
  quotedQuantity: number;
  deliveryDelay: number;
  shippingCost?: number;
  quoteNotes?: string;
}) {
  const url = `requests/${params.id}/submit-quote`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error submitting quote:", error);
  }
}

function approveQuoteApi(params: { id: string; approved: boolean; rejectionReason?: string }) {
  const url = `requests/${params.id}/approve-quote`;
  try {
    return getApiInstance().put(url, { approved: params.approved, rejectionReason: params.rejectionReason });
  } catch (error) {
    console.error("Error approving quote:", error);
  }
}

export {
  getRequests,
  createRequestApi,
  getRequest,
  updateRequestApi,
  updateStatusRequestApi,
  deleteRequestApi,
  assignAgentsApi,
  submitQuoteApi,
  approveQuoteApi,
};
